import React from "react";
import { brl } from "@/lib/api";

export const PlanPicker = ({ plans, selected, onSelect }) => (
  <div className="space-y-2" data-testid="plan-picker">
    <div className="text-[11px] uppercase tracking-[0.16em] text-slate-400">Escolha sua opção</div>
    {plans.map((p, i) => {
      const active = i === selected;
      return (
        <button
          key={`${p.name}-${i}`}
          type="button"
          onClick={() => onSelect(i)}
          data-testid={`plan-option-${i}`}
          className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3 text-left transition-colors ${active ? "border-[#FFB30F]/70 bg-[#FFB30F]/[0.07]" : "border-white/10 bg-white/[0.02] hover:border-white/20"}`}
        >
          <span className={`w-4 h-4 shrink-0 rounded-full border-2 ${active ? "border-[#FFB30F] bg-[#FFB30F] shadow-[inset_0_0_0_3px_#121824]" : "border-white/25"}`} />
          <span className="min-w-0 flex-1">
            <span className="block font-display font-bold text-sm sm:text-base truncate">{p.name}</span>
            {p.description && <span className="block text-xs text-slate-400 truncate">{p.description}</span>}
          </span>
          <span className="font-display font-black tabular-nums text-sm sm:text-base">{brl(p.price)}</span>
        </button>
      );
    })}
  </div>
);
